import { DateTime } from 'luxon';
import { IConfigObjectBase } from '../../interfaces/config-objects/config-object-base';
import { Guid } from '../guid';
import { ScheduleTaskConfig } from '../schedule-tasks/schedule-task-config';

export class UniqueHistoryConfig implements IConfigObjectBase {
	id: string = Guid();
	name = '';
	description?: string;
	dateCreated: DateTime = DateTime.now();
	lastUpdated: DateTime = DateTime.now();

	scheduleProps: ScheduleTaskConfig = new ScheduleTaskConfig();

	constructor(init?: Partial<UniqueHistoryConfig>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
